import React from "react";

import { default as BaseTermsAndConditions } from "../legal/termsconditions";
import { getServerSideTranslationsWrapper } from "../../src/nextUtils";

const TermsAndConditions = () => <BaseTermsAndConditions />;

export const getStaticProps = getServerSideTranslationsWrapper();

export default TermsAndConditions;
